<template>
    <Dialog v-model:visible="isVisible" header="Authorization Data" @hide="hide()" @show="show()" :dismissable="false"
        :draggable="false" :modal="true" :style="{ width: '50vw' }" :closable="false">
        <span v-show="errMessage" class="p-error">{{ errMessage }}</span>

        <div class="p-inputtext-sm p-fluid">
            <div class="grid">
                <div class="col-12">
                    <div class="field grid">
                        <label for="Unit" class="col-2">{{ $t('unit') }}</label>
                        <div class="col-10 md-10">
                            <Textarea ame="Unit" v-model="Unit" type="text" :placeholder="$t('unit')" :disabled="true"
                                :autoResize="true" />
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="Company" class="col-2">{{ $t('company') }}</label>
                        <div class="col-10 md-10">
                            <Textarea name="Company" v-model="Company" type="text" :placeholder="$t('company')"
                                :disabled="true" :autoResize="true" />
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="Functional" class="col-2">{{ $t('functional') }}</label>
                        <div class="col-10 md-10">
                            <Textarea name="Functional" v-model="Functional" type="text" :placeholder="$t('functional')"
                                :disabled="true" :autoResize="true" />
                        </div>
                    </div>
                    <div class="field grid">
                        <label for="Grade" class="col-2">{{ $t('grade') }}</label>
                        <div class="col-10 md-10">
                            <InputText name="Grade" v-model="Grade" type="text" :placeholder="$t('grade')" :disabled="true"
                                :autoResize="true" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="OK" class="p-button mr-2" @click="hide()" style="margin-top: -30px;" />
        </template>
    </Dialog>
</template>

<script>
export default {
    data() {
        return {
            errMessage: null,
            url: this.$API_URL + "auth/report_auth",
            Unit: 'All',
            Grade: null,
            Functional: null,
            Company: null
        };
    },
    props: {
        model: {
            type: Object,
            default: null,
        },
        isVisible: {
            type: Boolean,
            default: false,
        },
        initialErrorMessage: {
            type: String,
            default: ""
        },
    },
    mounted() {
        var self = this;
        this.$axios.get(this.url)
            .then((response) => {
                if (response.data.success) {
                    self.Unit = response.data.data.Unit;
                    self.Company = response.data.data.Company;
                    self.Grade = response.data.data.Grade;
                    self.Functional = response.data.data.Functional;
                }
            })
            .catch(function (error) {
                alert(error);
            });
    },
    methods: {
        show() {
            if (this.initialErrorMessage) {
                this.errMessage = this.initialErrorMessage;
            }
        },
        hide(changeSuccess, message) {
            this.errMessage = null;
            this.$emit("update:isVisible", false);
            this.$emit("hide", {
                success: changeSuccess,
                message: message
            });
        }
    },
    emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
